/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import PropTypes from 'prop-types';
import { legendStyles } from './styles';
import { formatValue } from 'utilities/utils';
import { defaultColorScale, removeFractionalTicks } from 'widgets/map/helpers';
import * as d3 from 'd3';
import { readableColor } from 'polished';

// For representing continuous data
export function Legend({ dimensions, maxValue }) {
	const { width } = dimensions;
	const minWidth = 200;

	const colorScale = defaultColorScale(maxValue);
	const xScale = d3
		.scaleLinear()
		.domain([0, maxValue])
		.range([0, width]);

	const startColor = colorScale(0);
	const endColor = colorScale(maxValue);

	const gradient = `linear-gradient(to right, ${startColor} , ${endColor})`;

	const ticks = removeFractionalTicks(xScale.ticks(4));

	return (
		<div
			css={legendStyles.container}
			style={{ width: Math.max(width, minWidth) }}
		>
			<div css={legendStyles.labelContainer}>
				{ticks.map((tick, i) => {
					const isFirst = i === 0;
					const positionStyles = isFirst
						? css`
								left: 0;
								transform: none;
						  `
						: css`
								right: ${width - xScale(tick)}px;
						  `;
					return (
						<div
							key={i}
							css={[
								legendStyles.tick,
								css`
									color: ${readableColor(colorScale(tick))};
									${positionStyles};
								`,
							]}
						>
							{formatValue(tick)}
						</div>
					);
				})}
			</div>
			<div css={legendStyles.gradient} style={{ backgroundImage: gradient }} />
		</div>
	);
}

Legend.propTypes = {
	dimensions: PropTypes.any,
	startColor: PropTypes.string,
	endColor: PropTypes.string,
	ticks: PropTypes.array,
};
